import { Australia } from "@faire/web/slate/icons/flags/Australia";
import { Austria } from "@faire/web/slate/icons/flags/Austria";
import { Belgium } from "@faire/web/slate/icons/flags/Belgium";
import { Canada } from "@faire/web/slate/icons/flags/Canada";
import { Denmark } from "@faire/web/slate/icons/flags/Denmark";
import { Finland } from "@faire/web/slate/icons/flags/Finland";
import { France } from "@faire/web/slate/icons/flags/France";
import { Germany } from "@faire/web/slate/icons/flags/Germany";
import { Ireland } from "@faire/web/slate/icons/flags/Ireland";
import { Italy } from "@faire/web/slate/icons/flags/Italy";
import { Luxembourg } from "@faire/web/slate/icons/flags/Luxembourg";
import { Netherlands } from "@faire/web/slate/icons/flags/Netherlands";
import { Norway } from "@faire/web/slate/icons/flags/Norway";
import { Portugal } from "@faire/web/slate/icons/flags/Portugal";
import { Spain } from "@faire/web/slate/icons/flags/Spain";
import { Sweden } from "@faire/web/slate/icons/flags/Sweden";
import { Switzerland } from "@faire/web/slate/icons/flags/Switzerland";
import { UnitedKingdom } from "@faire/web/slate/icons/flags/UnitedKingdom";
import { UnitedStates } from "@faire/web/slate/icons/flags/UnitedStates";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import React from "react";

interface IProps {
  country?: keyof typeof ISO3166Alpha3;
  size?: string;
}

export const hasCountryFlag = (country: keyof typeof ISO3166Alpha3) => {
  return (
    country === ISO3166Alpha3.USA ||
    country === ISO3166Alpha3.CAN ||
    country === ISO3166Alpha3.GBR ||
    country === ISO3166Alpha3.CHE ||
    country === ISO3166Alpha3.NOR ||
    country === ISO3166Alpha3.NLD ||
    country === ISO3166Alpha3.FRA ||
    country === ISO3166Alpha3.DEU ||
    country === ISO3166Alpha3.ESP ||
    country === ISO3166Alpha3.ITA ||
    country === ISO3166Alpha3.AUT ||
    country === ISO3166Alpha3.BEL ||
    country === ISO3166Alpha3.IRL ||
    country === ISO3166Alpha3.LUX ||
    country === ISO3166Alpha3.SWE ||
    country === ISO3166Alpha3.DNK ||
    country === ISO3166Alpha3.FIN ||
    country === ISO3166Alpha3.PRT ||
    country === ISO3166Alpha3.AUS
  );
};
export const CountryFlag: React.FC<IProps> = ({ country, size = "16px" }) => {
  switch (country) {
    case ISO3166Alpha3.USA:
      return <UnitedStates fontSize={size} />;
    case ISO3166Alpha3.CAN:
      return <Canada fontSize={size} />;
    case ISO3166Alpha3.GBR:
      return <UnitedKingdom fontSize={size} />;
    case ISO3166Alpha3.CHE:
      return <Switzerland fontSize={size} />;
    case ISO3166Alpha3.NOR:
      return <Norway fontSize={size} />;
    case ISO3166Alpha3.NLD:
      return <Netherlands fontSize={size} />;
    case ISO3166Alpha3.FRA:
      return <France fontSize={size} />;
    case ISO3166Alpha3.DEU:
      return <Germany fontSize={size} />;
    case ISO3166Alpha3.ESP:
      return <Spain fontSize={size} />;
    case ISO3166Alpha3.ITA:
      return <Italy fontSize={size} />;
    case ISO3166Alpha3.AUT:
      return <Austria fontSize={size} />;
    case ISO3166Alpha3.BEL:
      return <Belgium fontSize={size} />;
    case ISO3166Alpha3.IRL:
      return <Ireland fontSize={size} />;
    case ISO3166Alpha3.LUX:
      return <Luxembourg fontSize={size} />;
    case ISO3166Alpha3.SWE:
      return <Sweden fontSize={size} />;
    case ISO3166Alpha3.DNK:
      return <Denmark fontSize={size} />;
    case ISO3166Alpha3.FIN:
      return <Finland fontSize={size} />;
    case ISO3166Alpha3.PRT:
      return <Portugal fontSize={size} />;
    case ISO3166Alpha3.AUS:
      return <Australia fontSize={size} />;
    default:
      return null;
  }
};
